const staff = [
  {
    id: 1,
    lastName: "Мендес Рібейро",
    name: "Андерсон",
    position: "Головний тренер",
    birthDate: "02.07.1981",
    photo: "images/staff/Mendes_R_A.jpg",
  },
  {
    id: 2,
    lastName: "Остапов",
    name: "Іван Валерійович",
    position: "Тренер воротарів",
    birthDate: "14.02.1987",
    photo: "images/staff/Ostapov_I.jpg",
  },
  {
    id: 3,
    lastName: "Кватирук",
    name: "Геннадій Степанович",
    position: "Лікар",
    birthDate: "27.11.1968",
    photo: "images/staff/Kvatyruk_G.jpg", // TODO: додати фото
  },
  {
    id: 4,
    lastName: "Кузьменко",
    name: "Антон Миколайович",
    position: "Масажист",
    birthDate: "31.01.2002",
    photo: "images/staff/Kuzmenko_A.jpg",
  },
  {
    id: 5,
    lastName: "Френіс",
    name: "Михайло Михайлович",
    position: "Фізіотерапевт",
    birthDate: "30.09.1998",
    photo: "images/staff/Frenis.jpg",
  },
  {
    id: 6,
    lastName: "Слобода",
    name: "Ігор Володимирович",
    position: "Адміністратор",
    birthDate: "24.07.1990",
    photo: "images/staff/Sloboda_I.jpg", // TODO: додати фото
  },
  {
    id: 7,
    lastName: "Фортес Родрігес",
    name: "Фабрісіо",
    position: "Адміністратор",
    birthDate: "20.03.1989",
    photo: "images/staff/Fortes_R_F.jpg",
  },
  {
    id: 8,
    lastName: "Люлька",
    name: "Сергій Миколайович",
    position: "Асистент головного тренера",
    birthDate: "22.02.1990",
    photo: "images/staff/Lylka_S.jpg",
  },
];

export default staff;